"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseSelect = BaseSelect;
exports.selectClassNamePrefix = void 0;

var _map2 = _interopRequireDefault(require("lodash/map"));

var _isNil2 = _interopRequireDefault(require("lodash/isNil"));

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _find2 = _interopRequireDefault(require("lodash/find"));

var _compact2 = _interopRequireDefault(require("lodash/compact"));

var _button = require("./buttons/button");

var _checkbox = require("./checkbox");

var _media = require("react-components/media");

var _boxShadow = require("./styles/box-shadow");

var _styles = require("react-components/styles");

var _colors = require("./styles/colors");

var _styledTools = require("styled-tools");

var _fieldsStyledComponents = require("./forms/fields-styled-components");

var _typographyStyles = require("./typography/typography-styles");

var _react = _interopRequireWildcard(require("react"));

var _reactSelect = _interopRequireWildcard(require("react-select"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _excluded = ["ref"],
    _excluded2 = ["ref"],
    _excluded3 = ["children"],
    _excluded4 = ["actionLabel", "closeMenuOnSelect", "components", "disabled", "hideSelectedOptions", "isClearable", "isMulti", "name", "onAction", "onChange", "onClearValue", "onCloseMenuOnScroll", "options", "placeholder", "value"];

var _templateObject;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var addIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 16\"><path stroke=\"currentColor\" stroke-miterlimit=\"10\" d=\"M8 .576v14.847M15.423 8H.576\"/></svg>";
var caretIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\"><path stroke=\"currentColor\" stroke-miterlimit=\"10\" d=\"M19.25 9.4l-3.5 3.7c-.8.8-1.8 1.3-3 1.4h-1.6c-1.1-.1-2.1-.6-2.9-1.5l-3.5-3.8\"/></svg>";
var checkedIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\"><g stroke-width=\"2\"><rect class=\"checkbox-icon-stroke-color\" width=\"22\" height=\"22\" x=\"1\" y=\"1\" rx=\"5\"/><rect width=\"20\" height=\"20\" x=\"2\" y=\"2\" fill=\"currentColor\" rx=\"3\"/><path stroke=\"#fff\" stroke-miterlimit=\"10\" d=\"M17.688 8.745L12.3 15.358c-.421.512-.992.833-1.607.903h-.845c-.615-.07-1.187-.391-1.607-.903L6.313 13.04\"/></g></svg>";
var closeIcon = "<svg fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M13.25 2.75l-10.5 10.5m10.5 0L2.75 2.75\" stroke=\"currentColor\" stroke-miterlimit=\"10\"/></svg>";
var uncheckedIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\"><rect width=\"18\" height=\"18\" x=\"2.999\" y=\"2.846\" stroke=\"currentColor\" stroke-width=\"2\" rx=\"3\"/></svg>";
/**
 * `Value` type.
 */

/**
 * Export `selectClassNamePrefix`.
 */
var selectClassNamePrefix = 'react-select';
/**
 * Resolve select values.
 */

exports.selectClassNamePrefix = selectClassNamePrefix;

function resolveSelectValues(isMulti, options, value) {
  if ((0, _isNil2["default"])(value)) {
    return undefined;
  }

  if (isMulti) {
    return (0, _compact2["default"])((0, _map2["default"])(value, function (selectedValue) {
      var currentValue = (0, _find2["default"])(options, {
        value: selectedValue
      });

      if ((0, _isNil2["default"])(currentValue)) {
        return;
      }

      return {
        label: currentValue.label,
        value: currentValue.value
      };
    }));
  }

  return (0, _find2["default"])(options, {
    value: value
  });
}
/**
 * Resolve value.
 */


function resolveValue(data, isMulti) {
  if ((0, _isNil2["default"])(data) || (0, _isEmpty2["default"])(data)) {
    return undefined;
  }

  return isMulti ? (0, _map2["default"])(data, function (_ref) {
    var value = _ref.value;
    return value;
  }) : data.value;
}
/**
 * Select context.
 */


var SelectContext = /*#__PURE__*/(0, _react.createContext)({
  onAction: function onAction() {}
});
/**
 * `StyledReactSelect` styled component.
 */

var StyledReactSelect = (0, _styledComponents["default"])(_reactSelect["default"]).withConfig({
  displayName: "select__StyledReactSelect",
  componentId: "sc-5zlo3v-0"
})([".", "{&__control{background:none;border:0;border-radius:0;box-shadow:none;color:", ";display:block;padding:14px 68px 4px 10px;width:100%;", "}&__value-container{padding:0;", "}&__single-value{", " color:", ";margin:0;transition:color ", ";", "}}"], selectClassNamePrefix, (0, _styles.color)('secondary'), _styles.media.min('ms')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        padding-left: 14px;\n        padding-top: 16px;\n      "]))), (0, _styledTools.ifProp)('isMulti', (0, _styledComponents.css)(["flex-wrap:nowrap;"])), _fieldsStyledComponents.textDesktopStyle, (0, _styles.color)('secondary'), (0, _styledTools.theme)('animations.defaultTransition'), (0, _styledTools.ifProp)('isDisabled', (0, _styledComponents.css)(["color:", ";"], (0, _styles.color)('gray400'))));
/**
 * `IndicatorsContainer` styled component.
 */

var IndicatorsContainer = _styledComponents["default"].div.withConfig({
  displayName: "select__IndicatorsContainer",
  componentId: "sc-5zlo3v-1"
})(["align-items:center;display:flex;height:24px;justify-content:flex-end;position:absolute;right:16px;top:50%;transform:translateY(-50%);width:48px;"]);
/**
 * `CaretIcon` styled component.
 */


var CaretIcon = (0, _styledComponents["default"])(_media.Icon).attrs({
  'aria-hidden': true,
  icon: caretIcon
}).withConfig({
  displayName: "select__CaretIcon",
  componentId: "sc-5zlo3v-2"
})(["color:", ";max-width:initial;transition:0.25s ease;transition-property:color,transform;width:24px;", " ", ""], _colors.colors.gray500, (0, _styledTools.ifProp)('isFocused', (0, _styledComponents.css)(["transform:scaleY(-1);"])), (0, _styledTools.ifProp)('isDisabled', (0, _styledComponents.css)(["color:", ";"], (0, _styles.color)('gray400'))));
/**
 * `ClearIcon` styled component.
 */

var ClearIcon = (0, _styledComponents["default"])(_media.Icon).attrs({
  'aria-hidden': true,
  icon: closeIcon
}).withConfig({
  displayName: "select__ClearIcon",
  componentId: "sc-5zlo3v-3"
})(["color:", ";cursor:pointer;margin-right:6px;max-width:initial;transition:color 0.3s ease-out;width:16px;&:hover{color:", ";}"], _colors.colors.gray500, _colors.colors.gray600);
/**
 * `StyledButton` styled component.
 */

var StyledButton = (0, _styledComponents["default"])(_button.Button).withConfig({
  displayName: "select__StyledButton",
  componentId: "sc-5zlo3v-4"
})(["color:", ";flex:1;margin:8px;"], (0, _styles.color)('gray600'));
/**
 * `DropdownIndicator` component.
 */

var DropdownIndicator = function DropdownIndicator(props) {
  var _props$innerProps = props.innerProps,
      ref = _props$innerProps.ref,
      restInnerProps = _objectWithoutProperties(_props$innerProps, _excluded);

  return /*#__PURE__*/_react["default"].createElement(CaretIcon, _extends({}, restInnerProps, {
    isDisabled: props === null || props === void 0 ? void 0 : props.isDisabled,
    isFocused: props === null || props === void 0 ? void 0 : props.isFocused,
    ref: ref
  }));
};
/**
 * `ClearIndicator` component.
 */


var ClearIndicator = function ClearIndicator(props) {
  var _props$innerProps2 = props.innerProps,
      ref = _props$innerProps2.ref,
      restInnerProps = _objectWithoutProperties(_props$innerProps2, _excluded2);

  return /*#__PURE__*/_react["default"].createElement(ClearIcon, _extends({}, restInnerProps, {
    ref: ref
  }));
};
/**
 * `BackgroundColorProps` type.
 */


/**
 * Get background color.
 */
function getBackgroundColor(backgroundColorProps) {
  var isFocused = backgroundColorProps.isFocused,
      isSelected = backgroundColorProps.isSelected,
      theme = backgroundColorProps.theme;

  if (isSelected) {
    return theme.colors.info100;
  }

  if (isFocused) {
    return theme.colors.gray200;
  }

  return theme.colors.white;
}
/**
 * `Option` type.
 */


/**
 * Get menu styles.
 */
function getMenuStyles(theme, isMulti, hasMenuWithAction) {
  return {
    menu: function menu(styles) {
      return _objectSpread(_objectSpread({}, styles), {}, {
        backgroundColor: theme.colors.white,
        border: 0,
        borderRadius: '6px',
        boxShadow: _boxShadow.boxShadow.card,
        display: 'flex',
        flexDirection: 'column',
        margin: '4px 0 4px'
      });
    },
    menuList: function menuList(styles) {
      return _objectSpread(_objectSpread({}, styles), {}, {
        padding: 0
      });
    },
    menuPortal: function menuPortal(styles) {
      return _objectSpread(_objectSpread({}, styles), {}, {
        zIndex: 100
      });
    },
    multiValue: function multiValue(styles) {
      return _objectSpread(_objectSpread({}, styles), {}, {
        ':not(:first-of-type):before': {
          content: '", "',
          display: 'block',
          width: '6px'
        },
        backgroundColor: 'transparent',
        borderRadius: 'none',
        display: 'flex',
        margin: 0,
        minWidth: 'none'
      });
    },
    multiValueLabel: function multiValueLabel(styles) {
      return _objectSpread(_objectSpread({}, styles), {}, {
        borderRadius: 'none',
        color: theme.colors.secondary,
        padding: 0,
        paddingLeft: 0
      });
    },
    multiValueRemove: function multiValueRemove(styles) {
      return _objectSpread(_objectSpread({}, styles), {}, {
        display: 'none'
      });
    },
    option: function option(styles, _ref2) {
      var isFocused = _ref2.isFocused,
          isSelected = _ref2.isSelected;
      return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, styles), isMulti ? {
        alignItems: 'center',
        backgroundColor: isFocused ? theme.colors.gray200 : theme.colors.white,
        color: theme.colors.nightBlue,
        cursor: 'pointer',
        display: 'grid',
        gridColumnGap: '8px',
        gridTemplateAreas: '\'checkbox label\'',
        gridTemplateColumns: '20px 1fr',
        padding: '12px 16px 11px'
      } : {
        backgroundColor: getBackgroundColor({
          isFocused: isFocused,
          isSelected: isSelected,
          theme: theme
        }),
        color: isFocused || isSelected ? theme.colors.primary : theme.colors.nightBlue,
        cursor: isSelected ? 'default' : 'pointer',
        padding: '12px 16px 11px',
        pointerEvents: isSelected ? 'none' : 'auto'
      }), {}, {
        ':first-of-type': {
          borderRadius: '4px 4px 0 0'
        },
        ':hover': {
          '*': {
            color: theme.colors.blue
          },
          backgroundColor: theme.colors.gray200
        }
      }, hasMenuWithAction ? {
        borderBottom: "1px solid ".concat(theme.colors.gray300)
      } : {
        ':last-of-type': {
          paddingBottom: '12px'
        },
        ':not(:last-of-type)': {
          borderBottom: "1px solid ".concat(theme.colors.gray300)
        }
      }), {}, {
        fontFamily: _typographyStyles.typography.fontFamilies.inter,
        fontSize: '16px',
        fontWeight: '400',
        letterSpacing: '-0.5px',
        lineHeight: '22px'
      });
    }
  };
}
/**
 * `ReactSelectProps` type.
 */


/**
 * `MenuWithAction` component.
 */
function MenuWithAction(props) {
  var children = props.children,
      rest = _objectWithoutProperties(props, _excluded3);

  var _useContext = (0, _react.useContext)(SelectContext),
      actionLabel = _useContext.actionLabel,
      onAction = _useContext.onAction;

  return /*#__PURE__*/_react["default"].createElement(_reactSelect.components.Menu, rest, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children, actionLabel && onAction && /*#__PURE__*/_react["default"].createElement(StyledButton, {
    colorTheme: 'gray',
    icon: addIcon,
    iconSize: 'small',
    onClick: onAction,
    size: 'medium'
  }, actionLabel)));
}
/**
 * `CustomOptionProps` type.
 */


/**
 * `StyledCheckedIcon` styled component.
 */
var StyledCheckedIcon = (0, _styledComponents["default"])(_checkbox.CheckedIcon).attrs({
  icon: checkedIcon
}).withConfig({
  displayName: "select__StyledCheckedIcon",
  componentId: "sc-5zlo3v-5"
})(["grid-area:checkbox;", ""], (0, _styledTools.ifProp)('isSelected', (0, _styledComponents.css)(["opacity:1;"])));
/**
 * `StyledUncheckedIcon` styled component.
 */

var StyledUncheckedIcon = (0, _styledComponents["default"])(_checkbox.UncheckedIcon).attrs({
  icon: uncheckedIcon
}).withConfig({
  displayName: "select__StyledUncheckedIcon",
  componentId: "sc-5zlo3v-6"
})(["grid-area:checkbox;", ""], (0, _styledTools.ifProp)('isSelected', (0, _styledComponents.css)(["opacity:0;"])));
/**
 * `CustomOptionWithCheckbox` component.
 */

function CustomOptionWithCheckbox(props) {
  var isSelected = props.isSelected,
      label = props.label;
  return /*#__PURE__*/_react["default"].createElement(_reactSelect.components.Option, props, /*#__PURE__*/_react["default"].createElement(_checkbox.LabelText, null, label), /*#__PURE__*/_react["default"].createElement(StyledCheckedIcon, {
    isSelected: isSelected
  }), /*#__PURE__*/_react["default"].createElement(StyledUncheckedIcon, {
    isSelected: isSelected
  }));
}
/**
 * Export `BaseSelect` component.
 */


function BaseSelect(props) {
  var actionLabel = props.actionLabel,
      closeMenuOnSelect = props.closeMenuOnSelect,
      components = props.components,
      disabled = props.disabled,
      hideSelectedOptions = props.hideSelectedOptions,
      isClearable = props.isClearable,
      _props$isMulti = props.isMulti,
      isMulti = _props$isMulti === void 0 ? false : _props$isMulti,
      name = props.name,
      onAction = props.onAction,
      onChange = props.onChange,
      onClearValue = props.onClearValue,
      onCloseMenuOnScroll = props.onCloseMenuOnScroll,
      options = props.options,
      _props$placeholder = props.placeholder,
      placeholder = _props$placeholder === void 0 ? '' : _props$placeholder,
      value = props.value,
      rest = _objectWithoutProperties(props, _excluded4);

  var selectValues = resolveSelectValues(isMulti, options, value);
  var theme = (0, _react.useContext)(_styledComponents.ThemeContext);
  var hasMenuWithAction = !!actionLabel && !!onAction;
  var handleChange = (0, _react.useCallback)(function (data, _ref3) {
    var action = _ref3.action;

    if (onClearValue && action === 'clear') {
      onClearValue();
    }

    if (onChange) {
      return onChange(resolveValue(data, isMulti));
    }
  }, [isMulti, onChange, onClearValue]);
  return /*#__PURE__*/_react["default"].createElement(SelectContext.Provider, {
    value: {
      actionLabel: actionLabel,
      onAction: onAction
    }
  }, /*#__PURE__*/_react["default"].createElement(StyledReactSelect, _extends({
    "aria-labelledby": "".concat(name, "_label"),
    classNamePrefix: selectClassNamePrefix,
    closeMenuOnScroll: onCloseMenuOnScroll,
    closeMenuOnSelect: closeMenuOnSelect,
    components: _objectSpread(_objectSpread({
      ClearIndicator: ClearIndicator,
      DropdownIndicator: DropdownIndicator,
      IndicatorSeparator: '',
      IndicatorsContainer: IndicatorsContainer,
      LoadingIndicator: '',
      Menu: MenuWithAction
    }, isMulti ? {
      Option: CustomOptionWithCheckbox
    } : {}), components),
    hideSelectedOptions: hideSelectedOptions,
    inputId: name,
    isClearable: isClearable,
    isDisabled: disabled,
    isMulti: isMulti,
    menuPortalTarget: document.getElementById('select-menu-root'),
    name: name,
    onChange: handleChange,
    options: options,
    placeholder: placeholder,
    styles: getMenuStyles(theme, isMulti, hasMenuWithAction),
    value: selectValues
  }, rest)));
}